import debounce from 'lodash/debounce';
import { FC, useEffect, useMemo, useState } from 'react';
import { RangeSlider } from 'atoms/RangeSlider';
import { IRangeSlider, Values } from 'atoms/RangeSlider/types';
import { Span } from 'atoms/Typography';
import styles from './styles.module.css';

export const RangeSliderWithCurrency: FC<
  Omit<IRangeSlider, 'onChange'> & {
    currency: string;
    onChange: (values: Values) => void;
    selectedRange: number[];
  }
> = ({ currency, min = 0, max = 100, selectedRange, onChange, ...rest }) => {
  const [value, setValue] = useState<Values>(selectedRange);
  const makeAction = useMemo(
    () =>
      debounce((values) => {
        onChange(values);
      }, 500),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    if (selectedRange[0] === min && selectedRange[1] === max) {
      setValue([min, max]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRange]);

  const handleChange = (event: Event, values: number | Values) => {
    setValue(Array.isArray(values) ? values : [values]);

    if (!!onChange) {
      makeAction(values);
    }
  };

  return (
    <div className={styles.root}>
      <Span className={styles.from}>
        {min}
        <Span className={styles.currency}>{currency}</Span>
      </Span>
      <RangeSlider
        valueLabelFormat={(val) => (
          <Span className={styles.label}>
            {val}
            <Span className={styles.currency}>{currency}</Span>
          </Span>
        )}
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        {...rest}
      />
      <Span className={styles.to}>
        {max}
        <Span className={styles.currency}>{currency}</Span>
      </Span>
    </div>
  );
};
